import { setLocale, useLocale } from "../i18n/locale";

export function LanguageSwitch() {
  const locale = useLocale();
  return (
    <div className="language-switch" translate="no">
      <span className="small">中文</span>
      <button type="button" role="switch" aria-checked={locale === "en"} aria-label="English language / 英文模式"
        className="language-toggle" data-testid="language-switch" onClick={() => setLocale(locale === "zh" ? "en" : "zh")}>
        <span />
      </button>
      <span className="small">EN</span>
    </div>
  );
}
